/**
 * The providers, outermost first, and the router under them.
 *
 * React Aria's two root providers, as in the Studio — but the locale is fixed at `en` here,
 * because the app's chrome is English and RAC's built-in strings ("Remove", the drag-and-drop
 * announcements) should match the words around them. The *data* an admin edits is still
 * bilingual; the tool is not.
 */

import {
  I18nProvider as AriaI18nProvider,
  RouterProvider as AriaRouterProvider,
} from 'react-aria-components';
import type { JSX } from 'react';
import { RouterProvider, createBrowserRouter } from 'react-router';

import { AuthProvider } from './auth/AuthProvider.js';
import { routes } from './routes/routes.js';
import { ToastProvider } from './shell/ToastProvider.js';

const router = createBrowserRouter(routes);

export function App(): JSX.Element {
  return (
    <AriaI18nProvider locale="en">
      <AriaRouterProvider navigate={(to, options) => void router.navigate(to, options)}>
        <AuthProvider>
          <ToastProvider>
            <RouterProvider router={router} />
          </ToastProvider>
        </AuthProvider>
      </AriaRouterProvider>
    </AriaI18nProvider>
  );
}
